import styled from "styled-components"

export const MAIN_FONT_COLOR = "#37352f"
export const borderColorInput = "#d1d5db"

export const Title = styled.div`
  font-size: 1.125rem;
  color: #787878;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
`

export const Subtitle = styled.div`
  font-size: 1rem;
  color: #787878;
  font-weight: 500;
  text-transform: uppercase;
  display: flex;
  align-items: center;
`
